import i18n, { TFunction } from 'i18next'
import HttpApi from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

import { Instance, Languages, NS } from '@const/consts'
import LocalStorageService from '@services/localStorage'
import { getUrlParams } from './utils/utils'
import * as Sentry from '@sentry/browser'

const instance = window.location.hostname.match(/ils-brasil.com/g)?.[0]
  ? Instance.BR
  : window.location.hostname.match(/\.ru/g)?.[0]
  ? Instance.RU
  : window.location.hostname.match(/global|com.br|africa/g)?.[0] ??
    LocalStorageService.getInstance() ??
    Instance.GLOBAL;

LocalStorageService.setInstance(instance)


const isRussia = instance === Instance.RU;
const allLangs = Object.values(Languages);
const langsWithoutRussian = allLangs.filter((val) => val !== Languages.RU);
const lngFromLS = LocalStorageService.getLanguage() ?? Languages.EN;

let translates: string[] = langsWithoutRussian

if (isRussia) {
  translates = allLangs
}

const getLanguageAndRedirect = () => {
  let lang = getUrlParams(isRussia);

  if (lang === "none") {
    lang=lngFromLS;
  }

  return lang
}

i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    lng: getLanguageAndRedirect(),
    fallbackLng: translates,
    preload: translates,
    ns: NS,
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    debug: false,

    react: {
      nsMode: 'default',
    },

    interpolation: {
      escapeValue: false,
    },
  })
  .catch((err: TFunction) => {
    const errorText = 'i18n error'
    const errorLevel = 'fatal'
    const errorInfo = { err }

    Sentry.withScope((scope: Sentry.Scope) => {
      scope.setLevel(errorLevel)
      scope.setExtras(errorInfo)
      Sentry.captureException(new Error(errorText))
    })
  })

export default i18n
